import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import { CheckCircle2, AlertTriangle, Send, XCircle } from 'lucide-react';

export default function ConfirmationModal({
  isOpen,
  onClose,
  appointment,
  type = 'CONFIRM', // 'CONFIRM', 'REJECT', or 'CANCEL'
  onConfirm,
  loading = false,
}) {
  const isConfirm = type === 'CONFIRM';
  const isCancel = type === 'CANCEL';
  const isReject = type === 'REJECT';

  const getDefaultNote = () => {
    if (isConfirm) {
      return 'Sizning konsultatsiya arizangiz tasdiqlandi. Iltimos, belgilangan vaqtdan 10 daqiqa oldin tegishli hujjatlar bilan ofisimizga tashrif buyuring.';
    }
    if (isCancel) {
      return 'Kechirasiz, advokatning shoshilinch sud majlisi tufayli belgilangan uchrashuv bekor qilindi. Boshqa qulay vaqtni tanlashingizni so‘raymiz.';
    }
    return 'Afsuski, advokatning ushbu kungi bandligi yoki sud jarayoni tufayli arizangizni qabul qila olmaymiz. Boshqa vaqtni tanlashingizni so‘raymiz.';
  };

  const [note, setNote] = useState('');

  useEffect(() => {
    if (isOpen) {
      setNote(getDefaultNote());
    }
  }, [isOpen, type]);

  if (!appointment) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (note.trim().length < 5) return;
    onConfirm(appointment.id, note.trim());
  };

  const modalTitle = isConfirm
    ? 'Uchrashuvni Tasdiqlash'
    : isCancel
    ? 'Uchrashuvni Bekor Qilish'
    : 'Uchrashuvni Rad Etish';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={modalTitle}
      maxWidth="max-w-lg"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Summary of appointment */}
        <div className="bg-slate-50 border border-slate-200 rounded p-4 text-xs space-y-1.5">
          <div className="flex justify-between">
            <span className="text-slate-500">Bron raqami:</span>
            <span className="font-mono font-bold text-slate-800">{appointment.bookingReference}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Mijoz:</span>
            <span className="font-semibold text-slate-800">{appointment.clientName} ({appointment.clientPhone})</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Advokat:</span>
            <span className="text-slate-800">{appointment.lawyer?.fullName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Sana & Vaqt:</span>
            <span className="font-semibold text-slate-800">{appointment.appointmentDate} soat {appointment.startTime}</span>
          </div>
        </div>

        {/* Mandatory Note Section */}
        <div>
          <label className="block text-xs font-semibold uppercase tracking-wider mb-1">
            {isConfirm ? (
              <span className="flex items-center text-slate-800">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 mr-1" />
                Tasdiqlash eslatmasi (Mijozga SMS va bildirishnoma boradi - Majburiy *)
              </span>
            ) : isCancel ? (
              <span className="flex items-center text-amber-800">
                <AlertTriangle className="w-3.5 h-3.5 text-amber-600 mr-1" />
                Bekor qilish sababi (Mijozga SMS va bildirishnoma boradi - Majburiy *)
              </span>
            ) : (
              <span className="flex items-center text-rose-800">
                <XCircle className="w-3.5 h-3.5 text-rose-600 mr-1" />
                Rad etish sababi (Mijozga SMS va bildirishnoma boradi - Majburiy *)
              </span>
            )}
          </label>
          <textarea
            rows={4}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded text-xs focus:outline-none focus:border-[#c5a880] leading-relaxed"
            placeholder="Mijozga yuboriladigan izoh yoki sababni yozing..."
            required
          />
          <div className="flex items-center justify-between text-[11px] text-slate-500 mt-1">
            <span className={note.trim().length >= 5 ? 'text-emerald-600' : 'text-rose-600 font-semibold'}>
              Belgilar soni: {note.trim().length} (kamida 5 ta belgi shart)
            </span>
            <span>SMS va akkauntga yuboriladi</span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 pt-3 border-t border-slate-200">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 rounded text-xs font-medium text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Ortga qaytish
          </button>

          <button
            type="submit"
            disabled={loading || note.trim().length < 5}
            className={`inline-flex items-center px-5 py-2 rounded text-xs font-semibold transition-all cursor-pointer ${
              note.trim().length < 5
                ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                : isConfirm
                ? 'bg-emerald-700 hover:bg-emerald-800 text-white shadow-sm'
                : isCancel
                ? 'bg-amber-600 hover:bg-amber-700 text-white shadow-sm'
                : 'bg-rose-700 hover:bg-rose-800 text-white shadow-sm'
            }`}
          >
            {loading ? (
              'Bajarilmoqda...'
            ) : (
              <>
                <Send className="w-3.5 h-3.5 mr-1.5" />
                {isConfirm
                  ? 'Tasdiqlash va SMS yuborish'
                  : isCancel
                  ? 'Bekor qilish va SMS yuborish'
                  : 'Rad etish va SMS yuborish'}
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}
